'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const ipfsCore = '0.13.0';
const commit = '7375caa8805298fc671ed4080e1023aafe756151';
const interfaceIpfsCore = '^0.153.0';

exports.commit = commit;
exports.interfaceIpfsCore = interfaceIpfsCore;
exports.ipfsCore = ipfsCore;
